import { render, staticRenderFns } from "./Project8.vue?vue&type=template&id=c0a77fdc"
import script from "./Project8.vue?vue&type=script&lang=js"
export * from "./Project8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports